import {
  dateTimeFormat,
  localDateTimeFormat,
} from '../../../shared/constants/apiDateFormat';
import { getFormattedDate } from '../../../shared/utils/dateUtils';
import { getHumanizeInbodyType } from '../../../shared/utils/inbodyUtils';
import { SCAN_SOURCE_TYPE } from '../../constants/scanSourceType';
import { ScanDateOption, ScanMetadata } from '../../interfaces/scanMetadata';

export const getScanDateOptions = (scansMetadata: ScanMetadata[]): ScanDateOption[] => {
  return scansMetadata.map((scan) => {
    const label = getFormattedDate(
      scan.scanDateTime,
      localDateTimeFormat,
      dateTimeFormat,
    );

    const inbodyTypeLabel = getHumanizeInbodyType(scan.inbodyType);
    const isManual = scan.scanSourceType === SCAN_SOURCE_TYPE.MANUAL;
    const description = isManual ? `${inbodyTypeLabel} · Manual` : inbodyTypeLabel;

    return {
      label,
      description,
      value: scan.scanId,
      ...scan,
    };
  });
};
